import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AbstractComponent, Tabulation } from 'lib-trend-core';

@Component({
    selector: 'app-confirmation-close-attendance',
    // templateUrl: './confirmation-close-attendance.component.html',
    templateUrl: './confirmation-close-attendance.v2.component.html',
    styleUrl: './confirmation-close-attendance.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationCloseAttendanceComponent extends AbstractComponent implements OnInit {

  tabulationsSelected: Array<Tabulation> = new Array<Tabulation>();

  closeForced: boolean = false;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<ConfirmationCloseAttendanceComponent>,
    @Inject(MAT_DIALOG_DATA) public tabulations: Array<Tabulation>,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setupForm();
  }

  private setupForm() {
    this.formGroup = this.formBuilder.group({
      tabulation: [null],
      description: [null],
    });
  }

  handleJustClosingChange(event: Event): void {
    this.closeForced = (event.target as HTMLInputElement).checked;

    if (!!this.closeForced) {
      this.tabulationsSelected = undefined;
      this.formGroup.get('description')?.setValue('');
    }
  }

  onClose(): void {
    if (this.formGroup.invalid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }
    const result = {
      tabulations: this.closeForced ? '' : (this.formGroup.get('tabulation')?.value ? [this.formGroup.get('tabulation')?.value] : []),
      description: this.formGroup.get('description')?.value,
      closeForced: this.closeForced,
    };

    this.dialogRef.close(result);
  }
}
